export const NOTIFICATION_ENDPOINTS = {
  LIST: "/notification",
  SEND: "/notification",
  MARK_READ: (id) => `/notification/${id}/read`,
  DELETE: (id) => `/notification/${id}`,
  MARK_ALL_READ: "/notification/mark-all-read",
  CLEAR: "/notification",
};
